export function getBackgroundColor() {
  return getComputedStyle(document.documentElement).getPropertyValue(
    '--color-background-particles',
  );
}

export function getParticleColor() {
  return getComputedStyle(document.documentElement).getPropertyValue(
    '--color-shape-particles',
  );
}

export function getLinkColor() {
  return getComputedStyle(document.documentElement).getPropertyValue(
    '--color-link-particles',
  );
}
